import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=2c53fadd&"
import script from "./authority.vue?vue&type=script&lang=js&"
export * from "./authority.vue?vue&type=script&lang=js&"
import style0 from "./authority.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c53fadd')) {
      api.createRecord('2c53fadd', component.options)
    } else {
      api.reload('2c53fadd', component.options)
    }
    module.hot.accept("./authority.vue?vue&type=template&id=2c53fadd&", function () {
      api.rerender('2c53fadd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/authority/authority.vue"
export default component.exports